const baseStoreUrl = "Store"
const baseUsereUrl = "User"


  const endpoints = {
    getStoreListFilter:`${baseUsereUrl}/GetUserStore`,
    getStoreDetails:`${baseStoreUrl}`,
    addStore:`${baseStoreUrl}`,
    updatStoreWithPut:`${baseStoreUrl}`,
    updateStoreWithPatch:`${baseStoreUrl}`,
    deleteStore:`${baseStoreUrl}/Delete`,
    addImageByStore:`${baseStoreUrl}/AddImageByStore`,
    getTaxCertificates:`${baseStoreUrl}/GetDocumentByStore`,
    addTaxCertificate:`${baseStoreUrl}/AddDocumentByStore`,
    deleteTaxtCertificate:`${baseStoreUrl}/DeleteDocumentByStore`,
    getStoresByUser:`${baseUsereUrl}/GetUserStore`,

  };
  
  export default endpoints;
  